import React, { useState, useEffect } from 'react';
import bgImage from '../images/background.jpg';
import myLogo from '../images/logo.png';

const Login = () => {
    const [credentials, setCredentials] = useState({ Email: '', Password: '' });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isDesktop, setIsDesktop] = useState(true);

    const [isResetMode, setIsResetMode] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [resetMessage, setResetMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        const user = localStorage.getItem('user');
        if (token && user) {
            window.location.href = '/';
        }

        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/login`;

        try {
            const payload = {
                Email: credentials.Email.trim(),
                Password: credentials.Password
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            let result;
            try {
                result = await response.json();
            } catch (jsonErr) {
                throw new Error("Lỗi phản hồi từ máy chủ (Server không trả về JSON).");
            }

            if (response.ok && result.status === 'success') {
                localStorage.setItem('user', JSON.stringify(result.user));
                localStorage.setItem('accessToken', result.accessToken);

                localStorage.removeItem('X-User-Role-Id');
                localStorage.removeItem('X-User-Dept-Id');

                if (result.user.IsScvSynced === false) {
                    try {
                        await fetch(`${process.env.REACT_APP_API_BASE_URL}/scv-auto-sync`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${result.accessToken}`
                            },
                            body: JSON.stringify({
                                hoTen: result.user.FullName,
                                userId: result.user.Id
                            })
                        });
                    } catch (err) {
                        console.error("Lỗi đồng bộ SCV ngầm:", err);
                    }
                }

                window.location.href = '/';
            } else {
                setError(result.message || 'Sai thông tin đăng nhập!');
            }
        } catch (err) {
            console.error("[LỖI MẠNG/BACKEND]:", err);
            setError(`Lỗi kết nối tới máy chủ - Chi tiết: ${err.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setResetMessage({ type: '', text: '' });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/resetpassword`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Email: resetEmail.trim() })
            });

            const result = await response.json();

            if (response.ok && result.status === 'success') {
                setResetMessage({ type: 'success', text: result.message || 'Mật khẩu đã được gửi qua email!' });
                setResetEmail('');
            } else {
                setResetMessage({ type: 'error', text: result.message || 'Gửi yêu cầu thất bại!' });
            }
        } catch (err) {
            setResetMessage({ type: 'error', text: 'Lỗi kết nối máy chủ!' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', width: '100vw', overflowX: 'hidden' }}>
            <div style={{
                flex: 1,
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: isDesktop ? 'block' : 'none'
            }}>
            </div>

            <div style={{
                width: isDesktop ? '450px' : '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: isDesktop ? '40px' : '20px',
                backgroundColor: '#fff',
                boxShadow: isDesktop ? '-4px 0 15px rgba(0,0,0,0.1)' : 'none',
                zIndex: 1,
                boxSizing: 'border-box'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <img src={myLogo} alt="Logo của tôi" style={{ width: '150px', marginBottom: '15px' }} />
                    <h2 style={{ color: '#003399', margin: 0 }}>DUE NGHIÊN CỨU KHOA HỌC</h2>
                    <p style={{ color: '#666', fontSize: '14px', marginTop: '5px' }}>
                        {isResetMode ? "Khôi phục mật khẩu truy cập" : "Đăng nhập hệ thống quản lý khoa học"}
                    </p>
                </div>

                {!isResetMode ? (
                    <>
                        {error && <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px', borderRadius: '4px', marginBottom: '20px', fontSize: '14px', textAlign: 'center' }}>{error}</div>}

                        <form onSubmit={handleLogin}>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>Email đăng nhập</label>
                                <input
                                    type="email"
                                    name="Email"
                                    value={credentials.Email}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
                                />
                            </div>

                            <div style={{ marginBottom: '30px', position: 'relative' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>Mật khẩu</label>
                                <input type={showPassword ? "text" : "password"} name="Password" value={credentials.Password} onChange={handleChange} required
                                    style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', paddingRight: '40px' }}
                                />
                                <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                    style={{ position: 'absolute', right: '12px', top: '38px', cursor: 'pointer', color: '#666' }}
                                    onClick={() => setShowPassword(!showPassword)}></i>
                            </div>

                            <button type="submit" disabled={isLoading} style={{ width: '100%', padding: '12px', backgroundColor: '#003399', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', cursor: isLoading ? 'not-allowed' : 'pointer' }}>
                                {isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Đăng nhập"}
                            </button>
                        </form>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <span onClick={() => { setIsResetMode(true); setError(''); }} style={{ color: '#003399', cursor: 'pointer', fontSize: '14px', textDecoration: 'underline' }}>
                                Quên mật khẩu?
                            </span>
                        </div>
                    </>
                ) : (
                    <>
                        {resetMessage.text && (
                            <div style={{ backgroundColor: resetMessage.type === 'success' ? '#d4edda' : '#f8d7da', color: resetMessage.type === 'success' ? '#155724' : '#721c24', padding: '10px', borderRadius: '4px', marginBottom: '20px', fontSize: '14px', textAlign: 'center' }}>
                                {resetMessage.text}
                            </div>
                        )}

                        <form onSubmit={handleResetPassword}>
                            <div style={{ marginBottom: '25px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>Nhập Email của bạn</label>
                                <input
                                    type="email"
                                    value={resetEmail}
                                    onChange={(e) => setResetEmail(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
                                />
                            </div>

                            <button type="submit" disabled={isLoading} style={{ width: '100%', padding: '12px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', cursor: isLoading ? 'not-allowed' : 'pointer', marginBottom: '15px' }}>
                                {isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Gửi yêu cầu reset mật khẩu"}
                            </button>

                            <div style={{ textAlign: 'center' }}>
                                <span onClick={() => { setIsResetMode(false); setResetMessage({ type: '', text: '' }); }} style={{ color: '#666', cursor: 'pointer', fontSize: '14px', textDecoration: 'underline' }}>
                                    <i className="fa-solid fa-arrow-left"></i> Quay lại đăng nhập
                                </span>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default Login;